export const SIGN_IN_ROUTE = '/signin';
